const cards = [
  {
    id: 1,
    title: '香蕉视频·动作巨制专场',
    desc: '院线级动作大片高清呈现，震撼视听体验，肾上腺素飙升的观影之旅',
    tag: '动作',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20action%20movie%20scene%20with%20intense%20lighting%2C%20warm%20golden%20and%20deep%20red%20color%20tones%2C%20professional%20film%20photography%20style%2C%20dynamic%20composition%2C%20clean%20cinematic%20background&width=600&height=400&seq=card-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '红桃视频·高分悬疑剧场',
    desc: '烧脑悬疑剧集一网打尽，层层反转的精彩剧情，每一帧都是线索',
    tag: '悬疑',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20cinematic%20thriller%20scene%20with%20dramatic%20shadow%20lighting%2C%20warm%20amber%20and%20deep%20tones%2C%20suspenseful%20atmosphere%2C%20professional%20film%20photography%2C%20clean%20composition&width=600&height=400&seq=card-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '蜜桃视频·综艺欢乐汇',
    desc: '最热门综艺节目实时更新，搞笑、竞技、生活类应有尽有',
    tag: '综艺',
    image: 'https://readdy.ai/api/search-image?query=Bright%20energetic%20variety%20show%20stage%20scene%20with%20warm%20colorful%20lighting%2C%20entertainment%20atmosphere%2C%20cheerful%20vibrant%20tones%2C%20professional%20studio%20photography%20style%2C%20clean%20composition&width=600&height=400&seq=card-3-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '91视频·经典时光机',
    desc: '高清修复经典老片，重温那些年我们追过的银幕传奇',
    tag: '经典',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20cinema%20scene%20with%20warm%20sepia%20and%20golden%20tones%2C%20classic%20film%20projector%20aesthetic%2C%20retro%20movie%20atmosphere%2C%20soft%20lighting%2C%20clean%20composition%2C%20professional%20photography&width=600&height=400&seq=card-4-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '番茄精选·纪录片之旅',
    desc: '世界各地高分纪录片，足不出户看遍大千世界',
    tag: '纪录',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20documentary%20nature%20scene%20with%20warm%20natural%20lighting%2C%20sweeping%20landscape%20vista%2C%20professional%20wildlife%20photography%20style%2C%20rich%20earthy%20golden%20tones%2C%20clean%20composition&width=600&height=400&seq=card-5-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">精彩推荐</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">发现更多值得一看的精品影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.slice(0, 3).map((card) => (
            <div key={card.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer">
              <div className="relative aspect-[3/2] bg-background-200 overflow-hidden">
                <img src={card.image} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">{card.tag}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
          {cards.slice(3).map((card) => (
            <div key={card.id} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer sm:col-span-2 lg:col-span-2">
              <div className="flex flex-col sm:flex-row">
                <div className="relative aspect-[3/2] sm:w-2/5 bg-background-200 overflow-hidden flex-shrink-0">
                  <img src={card.image} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">{card.tag}</span>
                  </div>
                </div>
                <div className="p-5 flex-1 flex flex-col justify-center">
                  <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">{card.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}